import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import MessageReplyStateView
  from '@/components/TriggerSetup/conditions/MessageReplyState/MessageReplyStateSetupView.vue'
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'

const condition: () => EntityData = () => {
  return {
    'setupView': MessageReplyStateView,
    'structure': {
      'type': 'MessageReplyState',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('MessageReplyState') }`,
    'limited': getTagsByFieldKey('MessageReplyStateCondition'),
  }
}

export default condition
